import { gql } from "@apollo/client";
import { DEPOSIT_INFO } from "../fragments";

export const DEPOSIT_LIST = gql`
  query memberDeposits {
    memberDeposits {
      id
      profit
      amount
      returnDate
      createdAt
      status
    }
  }
`;

export const GET_DEPOSITS = gql`
  query deposits {
    deposits {
      ...depositInfo
    }
  }
  ${DEPOSIT_INFO}
`;
